/*
 * @Description:
 * @Date: 2020-09-24 14:47:49
 */
import comment from '@/components/comment';
const typeMap = {
  1: '文章',
  2: '文章',
  3: '直播',
  4: '录播',
  5: '问卷'
};
export default {
  components: { comment },

  data() {
    return {
      detail: {},
      ajax: null,
      saTimer: null // 神策定时上报
    };
  },
  methods: {
    eventCollection(val) {
      this.detail.isCollect = val;
    },
    // 初始化之后
    detailCallback() {}
  },
  async created() {
    let { id } = this.$route.params;
    if (this.ajax) {
      let {
        data: { data }
      } = await this.ajax({
        id
      });
      this.detail = data;
      let title = data.title || data.courseName;
      let imgUrl = data.videoPicUrl || data.picUrl;
      imgUrl &&
        (imgUrl += '?x-oss-process=image/resize,w_200,h_200/auto-orient,1'); // 分享图片限制大小，不自动旋转
      document.title = title;
      this.detailCallback && this.detailCallback();
      if (data.id) {
        this.$sa.re_contentview({
          type: typeMap[this.type], // 直播，录播，资讯，病例
          name: title, // 内容名字
          contentid: data.id, // 内容id
          zone_id: data.channelId // 专区
        });
        // 先上报一次
        this.$sa.re_contentview({
          type: typeMap[this.type] + '-看课时长', // 直播，录播，资讯，病例
          name: title, // 内容名字
          contentid: data.id // 内容id
        });
        this.saTimer = setInterval(() => {
          this.$sa.re_contentview({
            type: typeMap[this.type] + '-看课时长', // 直播，录播，资讯，病例
            name: title, // 内容名字
            contentid: data.id // 内容id
          });
        }, 1000 * 60);
        try {
          this.$wxShare({
            title,
            target: window.location.href,
            imgUrl,
            desc: title,
            callback: () => {
              this.$sa.re_interaction({
                type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
                contentype: typeMap[this.type], // 互动主体 直播，录播，资讯，病例，站内信，论坛, 调研
                contentid: data.id, // 内容id
                contentname: title
              });
            }
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  beforeDestroy() {
    this.saTimer && clearInterval(this.saTimer);
  }
};
